/**
 * Inline bootstrap that mirrors the Chakra color-mode cookie onto
 * `document.documentElement` before React hydrates, so Tailwind's `dark:`
 * variants render correctly on the first paint.
 *
 * Runs in root `app/layout.tsx` and `app/global-error.tsx` (which replaces
 * the root layout on an uncaught error and loses its script).
 *
 * Marketing routes have their own variant in `app/(public)/layout.tsx`.
 */
export const COLOR_MODE_BOOTSTRAP_SCRIPT = `
  try {
    const chakraMode = localStorage.getItem('chakra-ui-color-mode');
    if (chakraMode === 'dark' || (!chakraMode && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
      document.documentElement.classList.add('dark');
    }
  } catch (e) {}
`;
